export const TALL_CABINET_TOE_KICK_HEIGHT = 4.5;

const roundHeight = (height) => Math.round(height * 100) / 100;

export const getCabinetInteriorHeight = (cabinetHeight) => {
  const normalizedHeight = Number(cabinetHeight);
  if (!normalizedHeight || normalizedHeight <= TALL_CABINET_TOE_KICK_HEIGHT) {
    return 1;
  }

  return roundHeight(normalizedHeight - TALL_CABINET_TOE_KICK_HEIGHT);
};
